import { createSlice } from "@reduxjs/toolkit";
import {
  fetchCitys,
  fetchCountrys,
  fetchCitysByCountry,
  fetchEmailCheck,
  fetchForgetPassword,
  fetchLogin,
  fetchLogout,
  fetchSignup,
  fetchStatusColors,
  uploadImage,
} from "./apiThunk";
import {
  ToastNotifyError,
  ToastNotifySuccess,
} from "../../../components/CommonComponents/Toast/ToastNotify";
import { ROUTE_PATH } from "../../../constants/route";

const initialData = {
  auth: {},
  userData: {},
  signupFormData: {},
  rememberMe: false,
  cityNames: [],
  countryNames: [],
  cityNamesByCountry: [],
  colorStatus: [],
  isLoading: false,
  isLoadingCountry: false,
  isLoadingCity: false,
  error: null,
  errorCountry: null,
  errorCity: null,
};

const authenticationSlice = createSlice({
  name: "authentication",
  initialState: { ...initialData },
  reducers: {
    updateUserData: (state, action) => {
      state.userData = action.payload;
    },
    updateLogin: (state, action) => {
      state.auth = action.payload;
    },
    setReduxRememberMe: (state, action) => {
      state.rememberMe = action.payload;
    },
    logout: (state, action) => {
      state.auth = {};
      state.userData = {};
      state.signupFormData = {};
      state.colorStatus = [];
      state.rememberMe = false;
    },
    setSignupFormData: (state, action) => {
      state.signupFormData = { ...action.payload, ...state.signupFormData };
    },
    clearSignupFormData: (state) => {
      state.signupFormData = {};
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchLogin.fulfilled, (state, action) => {
      if (
        action?.payload?.response?.data?.message ===
        "Seller profile is not approved yet."
      ) {
        window.location.href = ROUTE_PATH.SIGNUP_REGISTRATIONS_EXISTS;
      } else if (
        action?.payload?.response?.data?.message === "Invalid credentials"
      ) {
        return;
      } else if (action?.payload?.data?.data?.user_type !== "S") {
        ToastNotifyError(
          "This account is registered as a buyer. Please log in as a buyer"
        );
        return;
      } else {
        state.auth = action?.payload;
      }
    });
    builder.addCase(fetchLogin.rejected, (state, action) => {
      state.auth = {
        error: true,
        errors: action.payload.data,
      };
      ToastNotifyError("Failed Login");
    });
    builder.addCase(fetchLogout.fulfilled, (state, action) => {
      state.auth = {};
      state.userData = {};
      state.signupFormData = {};
      state.rememberMe = false;
      ToastNotifySuccess(action?.payload?.data?.message);
    });
    builder.addCase(fetchLogout.rejected, (state, action) => {
      ToastNotifyError(action?.error?.message);
    });
    builder.addCase(fetchForgetPassword.fulfilled, (state, action) => {
      ToastNotifySuccess(action?.payload?.data?.message);
    });
    builder.addCase(fetchForgetPassword.rejected, (state, action) => {
      ToastNotifyError(action?.error?.message);
    });
    builder.addCase(fetchEmailCheck.fulfilled, (state, action) => {
      // ToastNotifySuccess(action?.payload?.message);
    });
    builder.addCase(fetchEmailCheck.rejected, (state, action) => {
      ToastNotifyError(action?.error?.message);
    });
    builder.addCase(fetchSignup.fulfilled, (state, action) => {
      state.userData = action?.payload?.data;
      state.signupFormData = {};
    });
    builder.addCase(fetchSignup.rejected, (state, action) => {
      state.auth = {
        error: true,
        errors: action.payload?.data,
      };
      ToastNotifyError("Signup failed. Please try again.");
    });
    builder.addCase(uploadImage.fulfilled, (state, action) => {
      ToastNotifySuccess("Image uploaded successfully!");
    });
    builder.addCase(uploadImage.rejected, (state, action) => {
      ToastNotifyError("Image upload failed. Please try again.");
    });
    builder.addCase(fetchCitys.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(fetchCitys.fulfilled, (state, action) => {
      state.isLoading = false;
      state.cityNames = action.payload.names || [];
    });
    builder.addCase(fetchStatusColors.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(fetchStatusColors.fulfilled, (state, action) => {
      state.isLoading = false;
      state.colorStatus = action.payload;
    });
    builder.addCase(fetchStatusColors.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });
    builder.addCase(fetchCountrys.pending, (state) => {
      state.isLoadingCountry = true;
      state.errorCountry = null;
    });
    builder.addCase(fetchCountrys.fulfilled, (state, action) => {
      state.isLoadingCountry = false;
      state.countryNames = action.payload.data || [];
    });
    builder.addCase(fetchCountrys.rejected, (state, action) => {
      state.isLoadingCountry = false;
      state.errorCountry = action.error.message;
    });
    builder.addCase(fetchCitysByCountry.pending, (state) => {
      state.errorCity = null;
    });
    builder.addCase(fetchCitysByCountry.fulfilled, (state, action) => {
      state.cityNamesByCountry = action.payload.data || [];
    });
    builder.addCase(fetchCitysByCountry.rejected, (state, action) => {
      state.errorCity = action.error.message;
    });
  },
});

const {
  actions: {
    updateUserData,
    updateLogin,
    logout,
    setReduxRememberMe,
    setSignupFormData,
    clearSignupFormData,
  },
  reducer,
} = authenticationSlice;
const selectorAuthentication = (state) => state.authentication;

export {
  updateUserData,
  updateLogin,
  clearSignupFormData,
  setSignupFormData,
  setReduxRememberMe,
  logout,
  fetchForgetPassword,
  selectorAuthentication,
};

export default reducer;
